/** How far a finger moves before its direction is read. Shorter than the browser's own wait before it scrolls. */
export const DECIDE_PX = 3;
/** Holding a card still this long makes any direction a drag, even sideways in a hand that scrolls. */
export const HOLD_MS = 250;
/** A swipe scrolls the hand only when it's this many times wider than tall: flatter than about 25 degrees. */
export const SCROLL_SLOPE = 2;

export const DRAG = 'drag';
export const SCROLL = 'scroll';

/**
 * What a touch on a hand card means, read from its first few pixels: null while it's too short to tell. A card drags
 * in every direction; the one exception is a quick, nearly flat swipe in a hand wider than the screen, which scrolls it.
 */
export const gestureIntent = ({ dx, dy, heldMs, handScrolls }) => {
  if (Math.hypot(dx, dy) < DECIDE_PX) {
    return null;
  }
  const flat = Math.abs(dx) > SCROLL_SLOPE * Math.abs(dy);
  return flat && handScrolls && heldMs < HOLD_MS ? SCROLL : DRAG;
};

/** Whether anything around the element scrolls sideways right now (the hand, once it holds more than fits). */
export const scrollsSideways = (element) => {
  for (let node = element && element.parentElement; node; node = node.parentElement) {
    const { overflowX } = window.getComputedStyle(node);
    if ((overflowX === 'auto' || overflowX === 'scroll') && node.scrollWidth > node.clientWidth) {
      return true;
    }
  }
  return false;
};
